import { Question } from "react-bootstrap-icons";
import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const orderService = {
  getAllOrders,
  getOverview,
  findAlyanteOrder,
  getOrderById,
  deleteById,
  getDistinctByField
};

const { apiUrl, apiVer } = defineConfig.ORDER_SERVICE;

function getApiPath(){
  return (apiUrl + apiVer + "/order");
}

function getAllOrders (page, pageSize = 10, filters = {}, sorter = {}) {
  let queryParams = [];
  let sortType =  sorter.order === 'descend' ? 'desc' : 'asc';
  let sortValue = sorter.field || "creationDate"
  
  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/" + page + "/" + pageSize + "/" + sortValue + "/" + sortType + queryString;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
} 

/** counts of the orders list tiles: ALL, PLATFORM, ALYANTE, NOT_INVOICED, VALUE_YEAR */
function getOverview() {
  return fetch(getApiPath() + "/summary/overview", { method: "GET", headers: authHeader("application/json") })
    .then(handleResponse);
}

/** the platform order of an Alyante document (company optional), or null */
// date (YYYY-MM-DD) and clientCode pick the right document: the number repeats within a year
function findAlyanteOrder({ company, number, year, date, clientCode }) {
  const params = new URLSearchParams({ number, year });
  if (company) params.append("company", company);
  if (date) params.append("date", String(date).slice(0, 10));
  if (clientCode) params.append("clientCode", clientCode);
  return fetch(getApiPath() + "/alyante/find?" + params.toString(), { method: "GET", headers: authHeader("application/json") })
    .then(r => (r.ok ? r.json() : null));
}

function getOrderById(id) {
  const url = getApiPath() + `/read/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deleteById(id) {
  const url = getApiPath() + `/delete/${id}`;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json")
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getDistinctByField(field){  
  const url = getApiPath() + `/all/filter/${field}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}